module.exports = __webpack_public_path__ + "be8072fda99369f61e0ae6cc4f252dfc.png";